import React from 'react';
import { useTranslation } from 'react-i18next';
import { toPlainText } from 'modules/editor/utils';
import type { BankQuestion } from '../types';

/** List-only summary; the preview drawer retains the original rich content. */
export function QuestionSummary({ question }: { question: BankQuestion }) {
  const { t } = useTranslation();
  const isPassage = question.type === 'PASSAGE';
  const text = (isPassage
    ? toPlainText(question.passageTitle) || toPlainText(question.passageText)
    : '') || toPlainText(question.prompt) || t(isPassage ? 'passage' : 'question');

  return (
    <div className="min-w-0 space-y-0.5">
      <p className={`${isPassage ? 'line-clamp-1' : 'line-clamp-2'} whitespace-normal leading-5 [overflow-wrap:anywhere]`}>
        {text}
      </p>
      {isPassage && (
        <p className="text-xs font-normal leading-4 text-muted-foreground">
          {t('qb_subquestion_count', { count: question.subQuestions?.length ?? 0 })}
        </p>
      )}
    </div>
  );
}
